import { render, staticRenderFns } from "./MapBanner.vue?vue&type=template&id=0bb46afe&"
import script from "./MapBanner.vue?vue&type=script&lang=js&"
export * from "./MapBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports